module.exports = __webpack_public_path__ + "16_hair_brown.52d1ad71.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/16_hair_brown.png
// module id = hSsO
// module chunks = 0